import { Paper, Group, Text, Box, Skeleton } from '@mantine/core';
import { IconList, IconLanguage, IconWorld } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { useContentAnalytics } from '@hooks/useContentAnalytics';
import styles from './Stats.module.scss';

const StatPlaceholder = () => {
  return (
    <Paper className={styles.stats__card} withBorder>
      <Group justify="space-between" align="center">
        <Group align="center" gap="sm">
          <Skeleton height={32} circle />
          <Skeleton height={16} width={80} radius="xl" />
        </Group>
        <Skeleton height={24} width={40} radius="xl" />
      </Group>
    </Paper>
  );
};

export const StatsSummary = () => {
  const { t } = useTranslation();
  const { total, langsCount, sourcesCount } = useContentAnalytics();

  const stats = [
    {
      label: t('stats.total'),
      value: total,
      icon: <IconList size={20} stroke={1.8} />,
      color: '#339af0',
    },
    {
      label: t('stats.langs'),
      value: langsCount,
      icon: <IconLanguage size={20} stroke={1.8} />,
      color: '#fab005',
    },
    {
      label: t('stats.sources'),
      value: sourcesCount,
      icon: <IconWorld size={20} stroke={1.8} />,
      color: '#51cf66',
    },
  ];

  const hasData = total > 0 || langsCount > 0 || sourcesCount > 0;

  if (!hasData) return null;

  return (
    <Group grow>
      {hasData ? (
        stats.map((stat, idx) => (
          <Paper key={idx} className={styles.stats__card} withBorder>
            <Group justify="space-between" align="center">
              <Group align="center" gap="sm">
                <Box
                  style={{
                    backgroundColor: `${stat.color}22`,
                    color: stat.color,
                    borderRadius: '50%',
                    padding: 6,
                    display: 'flex',
                  }}
                >
                  {stat.icon}
                </Box>
                <Text className={styles.stats__label}>{stat.label}</Text>
              </Group>
              <Text className={styles.stats__value}>{stat.value}</Text>
            </Group>
          </Paper>
        ))
      ) : (
        <>
          <StatPlaceholder />
          <StatPlaceholder />
          <StatPlaceholder />
        </>
      )}
    </Group>
  );
};
